import { createSlice } from '@reduxjs/toolkit';
import {
  CreateProduct,
  DeleteProduct,
  EditProductDetail,
  GetAllProduct,
  GetAllProductById,
  GetAllProductCount,
  GetSingleProductDetails,
  SearchForProductsByTitle,
  UploadProductImages,
  UploadProductThu,
} from './product_services_syn';

export const productSlice = createSlice({
  name: 'product',
  initialState: {
    product_loader: false,
    allProductLoader: true,
    productDeleteLoader: false,
    productEditLoader: false,
    proEditLoader: false,
    all_product_count_loader: false,
    all_product_count: 0,
    message: '',
    completeProduct: [],
    productDetails: {},
    completeProductSearch: {},
    productImagesDetails: [],
    productthubnailDetails: {},
    productLimit: 20,
    productSkip: 0,
    editProductId: '',
    product_sort_by: 'date',
  },
  reducers: {
    clearState: (state) => {
      state.product_loader = false;
      state.message = '';
      state.completeProduct = [];
      state.allProductLoader = true;
      state.productDeleteLoader = false;
      state.productEditLoader = false;
      state.proEditLoader = false;
      state.all_product_count_loader = false;
      state.all_product_count = 0;
      state.productDetails = {};
      state.completeProductSearch = {};
      state.productImagesDetails = [];
      state.productthubnailDetails = {};
      state.productLimit = 10;
      state.productSkip = 0;
      state.editProductId = '';
      state.product_sort_by = 'date';

      return state;
    },

    updateProductSortBy: (state, { payload }) => {
      state.product_sort_by = payload;
    },

    updateProductSkip: (state, { payload }) => {
      state.productSkip = payload;
    },

    updateProductLimit: (state, { payload }) => {
      state.productLimit = payload;
    },

    updateProductDetails: (state, action) => {
      state.productDetails = action.payload;
    },

    updateCompleteProduct: (state, action) => {
      state.completeProduct = action.payload;
    },

    updateProductImageDetails: (state, action) => {
      state.productImagesDetails = action.payload;
    },

    updateProductId: (state, { payload }) => {
      state.editProductId = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(CreateProduct.pending, (state) => {
        state.product_loader = true;
      })
      .addCase(CreateProduct.fulfilled, (state, { payload }) => {
        state.product_loader = false;
        state.message = payload.message;
      })
      .addCase(CreateProduct.rejected, (state, { payload }) => {
        state.product_loader = false;
        state.message = payload.message;
      })
      .addCase(UploadProductImages.pending, (state) => {
        state.productEditLoader = true;
      })
      .addCase(UploadProductImages.fulfilled, (state, { payload }) => {
        state.productEditLoader = false;
        state.message = payload.message;
        state.productImagesDetails = payload.data;
      })
      .addCase(UploadProductImages.rejected, (state, { payload }) => {
        state.productEditLoader = false;
        state.message = payload.message;
      })
      .addCase(UploadProductThu.pending, (state) => {
        state.productEditLoader = true;
      })
      .addCase(UploadProductThu.fulfilled, (state, { payload }) => {
        state.productEditLoader = false;
        state.message = payload.message;
        state.productthubnailDetails = payload.data;
      })
      .addCase(UploadProductThu.rejected, (state, { payload }) => {
        state.productEditLoader = false;
        state.message = payload.message;
      })
      .addCase(GetAllProduct.pending, (state) => {
        state.product_loader = true;
      })
      .addCase(GetAllProduct.fulfilled, (state, { payload }) => {
        state.product_loader = false;
        state.message = payload?.message;
        state.completeProduct = payload?.data;
      })
      .addCase(GetAllProduct.rejected, (state, { payload }) => {
        state.product_loader = false;
        state.message = payload?.message;
      })

      .addCase(GetAllProductById.pending, (state) => {
        state.product_loader = true;
      })
      .addCase(GetAllProductById.fulfilled, (state, { payload }) => {
        state.product_loader = false;
        state.message = payload?.message;
        state.completeProduct = payload?.data;
      })
      .addCase(GetAllProductById.rejected, (state, { payload }) => {
        state.product_loader = false;
        state.message = payload?.message;
      })
      .addCase(DeleteProduct.pending, (state) => {
        state.productDeleteLoader = true;
      })
      .addCase(DeleteProduct.fulfilled, (state, { payload }) => {
        const filterData = state.completeProduct?.docs?.filter(
          (item) => item._id !== payload?.data?._id
        );

        state.completeProduct = {
          ...state.completeProduct,
          docs: filterData,
        };

        state.productDeleteLoader = false;
        state.message = payload.message;

        state.editProductId = '';
      })
      .addCase(DeleteProduct.rejected, (state, { payload }) => {
        state.productDeleteLoader = false;
        state.message = payload.message;

        state.editProductId = '';
      })
      .addCase(GetSingleProductDetails.pending, (state) => {
        state.product_loader = true;
      })
      .addCase(GetSingleProductDetails.fulfilled, (state, { payload }) => {
        state.product_loader = false;
        state.message = payload.message;
        state.productDetails = payload.data;
      })
      .addCase(GetSingleProductDetails.rejected, (state, { payload }) => {
        state.product_loader = false;
        state.message = payload.message;
      })
      .addCase(EditProductDetail.pending, (state) => {
        state.proEditLoader = true;
      })
      .addCase(EditProductDetail.fulfilled, (state, { payload }) => {
        state.proEditLoader = false;
        state.message = payload.message;
      })
      .addCase(EditProductDetail.rejected, (state, { payload }) => {
        state.proEditLoader = false;
        state.message = payload.message;
      })

      .addCase(GetAllProductCount.pending, (state) => {
        state.all_product_count_loader = true;
      })
      .addCase(GetAllProductCount.fulfilled, (state, { payload }) => {
        state.all_product_count_loader = false;
        state.message = payload.message;
        state.all_product_count = payload?.data;
      })
      .addCase(GetAllProductCount.rejected, (state, { payload }) => {
        state.all_product_count_loader = false;
        state.message = payload.message;
      })

      .addCase(SearchForProductsByTitle.pending, (state) => {
        state.product_loader = true;
      })
      .addCase(SearchForProductsByTitle.fulfilled, (state, { payload }) => {
        state.product_loader = false;
        state.message = payload.message;
        state.completeProductSearch = payload?.data;
      })
      .addCase(SearchForProductsByTitle.rejected, (state, { payload }) => {
        state.product_loader = false;
        state.message = payload.message;
      });
  },
});

export const {
  updateProductDetails,
  updateCompleteProduct,
  updateProductSkip,
  updateProductLimit,
  updateProductImageDetails,
  updateProductId,
  updateProductSortBy,
} = productSlice.actions;
export const productSelector = (state) => state.product;

export default productSlice.reducer;
